import { useTranslation } from 'react-i18next';
import useErrorStore, { setErrorActionSelector } from 'Core/stores/error';
import { useNavigate } from 'react-location';
import { useQuery } from 'react-query';
import cacheKeys from 'Core/hooks/queries/cacheKeys';
import { get } from 'Core/utils/platformApi';
import { errorPath } from 'Core/routes';

export function useGetPaymentInfo() {
  const { t } = useTranslation();
  const setError = useErrorStore(setErrorActionSelector);
  const navigate = useNavigate();

  return useQuery(cacheKeys.paymentInfo, async () => (await get('/payment/info')) ?? {}, {
    onError(e) {
      if (e) {
        setError(t('status.error.getPaymentInfoFailed') + ` - (${e.message})`);
        navigate({ to: errorPath, search: true });
      }
    },
  });
}
